import React from "react";
import localStorage from "~/tools/localStorage";

export const queryCachedSlippage = () =>
    localStorage.get("__uxuy_dex_cached_slippage_settings__");

const useSlippageSetting = () => {
    const [slippageValue, setSlippageValue] = React.useState<string>();

    React.useEffect(() => {
        queryCachedSlippage().then((val: string | undefined) => {
            setSlippageValue(val ?? undefined);
        });
    }, []);

    return slippageValue;
};

export default useSlippageSetting;